import React, { useState, createContext, useContext, useEffect } from "react";

const AlertMessageContext = createContext();
const AlertMessageActionsContext = createContext();

const AlertWithButtonContext = createContext();
const AlertWithButtonActionsContext = createContext();

export const useAlertWithButtonContext = () =>
  useContext(AlertWithButtonContext);
export const useAlertWithButtonActionsContext = () =>
  useContext(AlertWithButtonActionsContext);

export const useAlertMessageContext = () => useContext(AlertMessageContext);
export const useAlertMessageActionsContext = () =>
  useContext(AlertMessageActionsContext);
export function AlertMessageContextProvider({ children }) {
  const [showAlertMessage, setShowAlertMessage] = useState(false);
  const [isAlertSuccess, setIsAlertSuccess] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlertWithButton, setShowAlertWithButton] = useState(false);
  const setAlertMessageFromAPI = (
    showAlertMessage,
    isAlertSuccess,
    alertMessage
  ) => {
    setShowAlertMessage(showAlertMessage);
    setIsAlertSuccess(isAlertSuccess);
    setAlertMessage(alertMessage);
  };
  const setAlertWithButton = (_value) => {
    setShowAlertWithButton(_value);
  };
  return (
    <AlertMessageContext.Provider
      value={{
        showAlertMessage,
        isAlertSuccess,
        alertMessage,
      }}
    >
      <AlertMessageActionsContext.Provider value={{ setAlertMessageFromAPI }}>
        <AlertWithButtonContext.Provider value={showAlertWithButton}>
          <AlertWithButtonActionsContext.Provider value={setAlertWithButton}>
            {children}
          </AlertWithButtonActionsContext.Provider>
        </AlertWithButtonContext.Provider>
      </AlertMessageActionsContext.Provider>
    </AlertMessageContext.Provider>
  );
}
